import { Injectable } from '@angular/core';
import { CreateUserRequestDTO } from '../models/CreateUserRequestDTO';
import { UserResponseDTO } from '../models/UserResponseDTO';
import { Urls } from '../utilities/urls.component';
import { HttpHeadersService } from './http-headers.service';
import { HttpClient } from '@angular/common/http';
import { Utils } from '../utilities/util.component';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class UserService {
  // API_ENDPOINT:string;
  constructor(private http: HttpClient, private headers: HttpHeadersService) {
    // this.API_ENDPOINT=localStorage.getItem("ENDPOINT");
  }
  private userSubject = new BehaviorSubject<string>(this.getUserNameFromStorage());
  userName$ = this.userSubject.asObservable();

  updateUserName(name: string) {
    localStorage.setItem('userName', name);
    this.userSubject.next(name);
  }

  private getUserNameFromStorage(): string {
    return localStorage.getItem('userName') || '';
  }
  // this method used for resend invitation and invite user
  inviteUser(request: CreateUserRequestDTO) {
    if (Utils.isAdmin() && localStorage.getItem('WhichTeamTab') == 'Organisation') {
      var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.registerUser;
      return this.http.post<UserResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
    } else if (Utils.isAdmin()) {
      var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.registerAdminUser;
      return this.http.post<UserResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
    }
    var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.registerUser;
    return this.http.post<UserResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
  }
  updateUser(request: CreateUserRequestDTO) {
    if (Utils.isAdmin() && localStorage.getItem('WhichTeamTab') == 'Organisation') {
      var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.updateUser;
      return this.http.post<UserResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
    } else if (Utils.isAdmin()) {
      var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.updateAdminUser;
      return this.http.post<UserResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
    }
    var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.updateUser;
    return this.http.post<UserResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
  }

  deleteUser(request: any) {
    if (Utils.isAdmin() && localStorage.getItem('WhichTeamTab') == 'Organisation') {
      var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.deleteUser;
      return this.http.post<UserResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
    } else if (Utils.isAdmin()) {
      var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.deleteAdminUser;
      return this.http.post<UserResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
    }
    var url: string = Urls.API_ENDPOINT + Urls.SETTINGS.deleteUser;
    return this.http.post<UserResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
  }

  roleMatch(toBeMatched: string | number) {
    var roles = JSON.parse(localStorage.getItem('roleAccess')!);

    return roles[toBeMatched];
  }

  getNewLinkForUser(request: any) {
    var url: string = Urls.API_ENDPOINT + Urls.AUTH.getNewLinkForUser;
    return this.http.post<UserResponseDTO>(url, request, this.headers.getLoginHttpHeaders());
  }
}
